"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var rql_search_overview_1 = require("./rql_search_overview");
var rql_pagination_1 = require("./rql_pagination");
var rql_facets_1 = require("./rql_facets");
var lodash_1 = require("lodash");
var RQLSearchGrid = /** @class */ (function (_super) {
    tslib_1.__extends(RQLSearchGrid, _super);
    function RQLSearchGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RQLSearchGrid.prototype.filters = function () {
        return this.props.filters || lodash_1.get(this.props, 'search.filters', []);
    };
    RQLSearchGrid.prototype.render = function () {
        return (React.createElement("div", { className: "faceted-grid" },
            React.createElement("div", { className: "faceted-grid__inner" },
                React.createElement("div", { className: "faceted-grid__facets" }, this.props.hasFacets && !this.props.error &&
                    React.createElement(rql_facets_1.default, { filters: this.filters(), loading: this.props.loading, sidebarContent: this.props.sidebarContent })),
                React.createElement("div", { className: "faceted-grid__main" },
                    this.props.relatedSearchRow,
                    this.props.hasSearchOverview && !this.props.error &&
                        React.createElement(rql_search_overview_1.default, { filters: this.filters(), followButton: this.props.followButton, totalText: this.props.totalText, tipText: this.props.tipText, loading: this.props.loading }),
                    this.props.highlightedResultRow &&
                        React.createElement("div", { className: "mtb-gutter" }, this.props.highlightedResultRow),
                    this.props.cards,
                    this.props.hasPagination && !this.props.error && this.props.search &&
                        React.createElement(rql_pagination_1.default, { limit: this.props.search.limit, total: this.props.search.total, offset: this.props.search.offset }),
                    !this.props.loading && this.props.followBanner))));
    };
    RQLSearchGrid.defaultProps = {
        hasPagination: false,
        hasFacets: false,
        freeTextQueryParam: '',
        collectionHeader: '',
        relatedSearchRow: null,
        error: false,
    };
    return RQLSearchGrid;
}(React.Component));
exports.default = RQLSearchGrid;
//# sourceMappingURL=rql_search_grid.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/rql_search_grid.js
// module id = Jm0b
// module chunks = 0 1 2 3 9 10 14 20